var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckmarkcircleFilled = function SvgCheckmarkcircleFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.15 12c0 5.44 4.41 9.85 9.85 9.85 5.44 0 9.85-4.41 9.85-9.85 0-5.44-4.41-9.85-9.85-9.85-5.44 0-9.85 4.41-9.85 9.85Zm6.703.483 1.476 1.476 5.59-5.579a1.09 1.09 0 1 1 1.543 1.544l-6.356 6.355a1.09 1.09 0 0 1-1.543 0L7.31 14.026a1.09 1.09 0 1 1 1.543-1.543Z",
    fill: "currentColor"
  })));
};
export default SvgCheckmarkcircleFilled;